import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Input from '@/components/basicComponents/input';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';

interface AddInvestorHouseholdProps {
  isOpen: boolean;
  handleNewInvestorHousehold: (investorHouseholdName: string) => void;
  onClose: () => void;
}

const AddInvestorHousehold = ({ isOpen, handleNewInvestorHousehold, onClose }: AddInvestorHouseholdProps) => {
  const { control, handleSubmit } = useForm<{ investorHouseholdName: string }>({ defaultValues: { investorHouseholdName: '' } });

  const saveValue = (data: { investorHouseholdName: string }) => {
    handleNewInvestorHousehold(data.investorHouseholdName);
    onClose();
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Add New Household"
      confirmButton={{
        name: 'Save',
        onClick: handleSubmit(saveValue)
      }}
    >
      <ModalDescription>
        Create a new household for this investor. Household’s organize multiple investor entities; the name is often a client or family name.
      </ModalDescription>
      <Controller
        name="investorHouseholdName"
        control={control}
        rules={{
          required: {
            value: true,
            message: 'Investor Household Name is required'
          }
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Input
            label="Investor Household Name"
            placeholder="Provide a name"
            value={value || ''}
            onChange={onChange}
            errorText={error?.message}
            size="md"
            isRequiredField
            autoFocus
          />
        )}
      />
    </ModalWrappedContent>
  );
};

export default AddInvestorHousehold;

const ModalDescription = styled.div`
  font-size: 16px;
  line-height: 22.4px;
  text-align: center;
  padding-bottom: 35px;
  color: ${({ theme }) => theme.font.base};
`;
